(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mif-produktdetails"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.mif-tabs').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));

    function aktivieren(tab) {
      tabs.forEach(function (t) {
        var an = t === tab;
        t.setAttribute('aria-selected', an ? 'true' : 'false');
        t.tabIndex = an ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !an;
      });
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        aktivieren(t);
      });
      t.addEventListener('keydown', function (e) {
        var ziel = null;
        if (e.key === 'ArrowRight') ziel = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') ziel = tabs[(i - 1 + tabs.length) % tabs.length];
        if (ziel) {
          e.preventDefault();
          aktivieren(ziel);
          ziel.focus();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
